export default {
  "init":"init",
  "intro" : "Intro",
  "contact" : "Contact",
  "resume" : "CV",
  "project" : "Project",
  "copied" : "Copied to clipboard",

  "westKowloonTitle" : "West Kowloon Cultural District App",
  "westKowloonDescription" : "- Geolocation<br/>- Virtual signage<br/>- Instagram AR effect",
  "hkriTitle" : "Discovery Bay Funtastic Easter 2021",
  "hkriDescription" : "- WebAR<br/>- Geolocation<br/>- Treasure hunt map",
  "metrohitTitle" : "Metro Hit Awards 2020",
  "metrohitDescription" : "- WebAR<br/>- Take photos with singers",
  "shs618Title" : "Shanghai Street 618",
  "shs618Description" : "- WebAR<br/>- Facebook , Instagram AR Effect",
  "taiOTitle" : "AR Exploring Tai O",
  "taiODescription" : "- WebAR<br/>- Virtual signage<br/>- Photo-taking",
  "fhkcccTitle" : "The Hungry Ghost Festival <br/> The Rescuer of Mother",
  "fhkcccDescription" : "- VR Game",
  "csassTitle" : "Qing Yu An <br/>The Lantern Festival",
  "csassDescription" : "- VR Game",
  "AQTitle" : "AR Aquarium",
  "AQDescription" : "- Coloring AR interaction<br/>- Multiple players game",
  "ar101Title" : "101AR",
  "ar101Description" : "- Product<br/>- Customised AR learning experience",
  "ssTitle" : "Multiplayer Interactive Game",
  "ssDescription" : "Web-based mobile controller",
  "vendingTitle" : "Interactive souvenir machine",
  "vendingDescription" : "- Triggered by Facebook like",
  "vsTitle" : "Vidal Sassoon",
  "vsDescription" : "- AR, Face Recognition, Product Recognition",
  "skiiTitle" : "SK-II",
  "skiiDescription" : "Interactive product introduction",
  "oralBTitle" : "Oral-B",
  "oralBDescription" : "Interactive product introduction",
  "jureTitle" : "Jure Jewelry",
  "jureDescription" : "Interactive product introduction",
  "vehicleTitle" : "Vehicle E-catalog",
  "vehicleDescription" : "Interactive product introduction",
  "ive2Title" : "IVE VTC",
  "ive2Description" : "Interactive teaching",
  "ive1Title" : "IVE VTC",
  "ive1Description" : "Interactive teaching",
  "towngasTitle" : "Towngas",
  "towngasDescription" : "Interactive product introduction",
  "ggjTitle" : "Ouija Sequence",
  "ggjDescription" : "Global Game Jam 2016 <br/> Best theme integration",

}



// WEBPACK FOOTER //
// ./src/language/en.js